<template>
  <button type="button" class="mbtn btn-success" ref="btn">
    <i class="fa-solid fa-floppy-disk"></i>
    Save
  </button>
</template>

<script>
export default {
  methods: {
    setfocus() {
      this.$refs.btn.focus();
    },
  },
};
</script>
